export default __webpack_public_path__ + "static/Portrait-Medium-Web-e4d300b7733f82117fe396b2da9976b0.woff2";